import { GlobalStyles } from "./assets/style/appStyle.style";
import { CalcGPT } from "./components/Calculate";

export const App = () => {

  return (

    <>

      <GlobalStyles />
      <CalcGPT />

    </>

  );

}
